import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Account from "./pages/Account";
import Contact from "./pages/Contact";
import Trades from "./pages/Trades";
import Sessions from "./pages/Sessions";
import Payouts from "./pages/Payouts";
import Formation from "./pages/Formation";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Members from "./pages/Members";
import AdminPayouts from "./pages/Admin/Payouts";
import AdminGraduation from "./pages/Admin/Graduation";
import AdminPromotions from "./pages/Admin/Promotions";
import Stats from "./pages/Admin/Stats";
import Settings from "./pages/Settings";

import { AuthProvider } from "./contexts/AuthContext";
import AuthRoute from "./contexts/AuthContext/AuthRoute";
import AdminRoute from "./contexts/AuthContext/AdminRoute";
import Invite from "./pages/Invite";

import "./App.css";
import CguProvider from "./contexts/CguProvider";
import FundingReminderProvider from "./contexts/FundingReminderProvider";
import { PostLoginModalProvider } from "./contexts/PostLoginModalContext";
import {
    ConnectedThemeProvider,
    useThemeMode,
} from "./contexts/ThemeContext";
import { UnsavedChangesProvider } from "./contexts/UnsavedChangesContext";

const ThemedToastContainer = () => {
    const { theme } = useThemeMode();

    return (
        <ToastContainer
            draggable
            position="top-right"
            autoClose={5000}
            closeButton={true}
            theme={theme}
        />
    );
};

function App() {
    return (
        <Router>
            <AuthProvider>
                <ConnectedThemeProvider>
                    <ThemedToastContainer />
                    <PostLoginModalProvider>
                        <CguProvider>
                            <FundingReminderProvider>
                            <UnsavedChangesProvider>
                        <Routes>
                            <Route
                                path="*"
                                element={<Navigate to="/login" replace />}
                            />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route
                                path="/forgot-password"
                                element={<ForgotPassword />}
                            />
                            <Route
                                path="/reset-password"
                                element={<ResetPassword />}
                            />
                            <Route
                                path="/dashboard"
                                element={
                                    <AuthRoute>
                                        <Trades />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/trades"
                                element={
                                    <AuthRoute>
                                        <Trades />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/trades/session/:sessionId"
                                element={
                                    <AuthRoute>
                                        <Sessions />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/payouts"
                                element={
                                    <AuthRoute>
                                        <Payouts />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/formation"
                                element={
                                    <AuthRoute>
                                        <Formation />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/account/*"
                                element={
                                    <AuthRoute>
                                        <Account />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/invite"
                                element={
                                    <AuthRoute>
                                        <Invite />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/contact"
                                element={
                                    <AuthRoute>
                                        <Contact />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/admin/members"
                                element={
                                    <AuthRoute>
                                        <AdminRoute
                                            permission={"admin-members"}
                                        >
                                            <Members />
                                        </AdminRoute>
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/admin/payouts"
                                element={
                                    <AuthRoute>
                                        <AdminRoute
                                            permission={"admin-payouts"}
                                        >
                                            <AdminPayouts />
                                        </AdminRoute>
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/admin/stats"
                                element={
                                    <AuthRoute>
                                        <AdminRoute permission={"admin-stats"}>
                                            <Stats />
                                        </AdminRoute>
                                    </AuthRoute>
                                }
                            />
                    
                            <Route
                                path="/admin/promotions"
                                element={
                                    <AuthRoute>
                                        <AdminRoute permission={"admin-promotions"}>
                                            <AdminPromotions />
                                        </AdminRoute>
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/admin/graduation"
                                element={
                                    <AuthRoute>
                                        <AdminRoute
                                            permission={[
                                                "admin-graduation",
                                                "admin-formateur-graduation",
                                            ]}
                                        >
                                            <AdminGraduation />
                                        </AdminRoute>
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/admin/settings/*"
                                element={
                                    <AuthRoute>
                                        <Settings />
                                    </AuthRoute>
                                }
                            />
                        </Routes>
                            </UnsavedChangesProvider>
                            </FundingReminderProvider>
                        </CguProvider>
                    </PostLoginModalProvider>
                </ConnectedThemeProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
